module.exports = __webpack_public_path__ + "img/icon_guanli@2x.172aadc2.png";